export default class include {
  constructor() {
    // this.init();
  }

  init() {}

  load(url, parent) {
    return new Promise((resolve, reject) => {
      let xhr = new XMLHttpRequest();
      let method = 'GET';

      xhr.timeout = 5000;
      xhr.open(method, url, true);
      xhr.onload = function () {
        if (xhr.status === 200) {
          var restxt = xhr.responseText; //String型で取得
          parent.innerHTML = xhr.responseText; //完了
          resolve(xhr.responseText);
        } else {
          reject(new Error(xhr.responseText));
        }
      };

      xhr.onerror = function () {
        reject(new Error(xhr.statusText));
      };

      xhr.send();
    });
  }
}
